export default __webpack_public_path__ + "static/media/project3.0357179e.webp";